import queryString from 'query-string'

const getCountryFromQueryString = () => {
  const countryQueryStringParameterKey = 'sf_c'
  const countryFromQueryString = queryString
    .parse(window.location.search)[countryQueryStringParameterKey]

  return countryFromQueryString?.toLowerCase()
}

export default getCountryFromQueryString
